module.exports = __webpack_public_path__ + "img/45.1.f9e30346.jpg";